module.exports = __webpack_public_path__ + "images/emoji/us.9637792e471a3cb8bfea.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/us.png
// module id = AoMW
// module chunks = 1